import React from 'react';
import styled from '@cthings.co/styled-components';
import { CloseButton } from '@bit/first-scope.close-button';

import { colorFetchFDS as colorFetch } from '@cthings.co/styles-utils';
import { useTheme } from '@cthings.co/styled-components';

const Wrapper = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colorFetch('gray5')};
  border-radius: 50%;
`;

export const CloseButtonRound = ({ closeOnClick, ...props }: { closeOnClick: () => void; className?: string }) => {
  const theme = useTheme();
  const { gray2 } = theme.colors;

  return (
    <Wrapper {...props}>
      <CloseButton width={'20px'} height={'20px'} onClick={closeOnClick} strokeWidth={'2px'} color={gray2} />
    </Wrapper>
  );
};
